import {Settings} from "./Settings";
import Helpers from "./Helpers.js";
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import moment from 'moment';
const queryString = require('query-string');
const parseXml = require('xml2js').parseString;

function TryRead(xmlNode, tagname) {
    let childNode = xmlNode.getElementsByTagName(tagname);

    if (childNode) {
        childNode = childNode[0];
    }
    if (childNode) {
        return childNode.textContent;
    }
    return "";
}

class SearchHandler {

    constructor() {
        this.cache = [];
    }

    BuildSearchQuerystring(searchFields, page) {
        let qsObject = {};

        qsObject.page = page;

        let sortField = searchFields.fields.find(x=>x.isBeingSorted);
        if (sortField) {
            qsObject.sort = sortField.filterId;
            qsObject.sortDirection = sortField.sortDirection;
        }

        for (let i = 0; i < searchFields.fields.length; i++)
        {
            let searchField = searchFields.fields[i];
            if (searchField.filterId === "zip" && searchField.selectedValue.length > 0) {
                qsObject.zip =searchField.selectedValue;
            } else if (searchField.selectedValue.length > 0) {
                qsObject["opt" + searchField.filterId] = searchField.selectedValue;
            } else if (searchField.selectedValues.length > 0) {
                qsObject["opt" + searchField.filterId] = searchField.selectedValues;
            }
        }

        return queryString.stringify(qsObject);
    }

    PerformSearch(inventoryType, searchFields, page, inventoryCategoryId) {

        if (inventoryType === Settings.inventoryTypes.TRAILER ||
            inventoryType === Settings.inventoryTypes.CARGO ||
            inventoryType === Settings.inventoryTypes.TRUCK ||
            inventoryType === Settings.inventoryTypes.PART)
        {
            //<editor-fold desc="Create URL string">
            // Sort by newest record first
            let sortColumn = 1;
            let sortDirection = "desc";

            let sortField = searchFields.fields.find(x=>x.isBeingSorted);
            if (sortField) {
                sortColumn = sortField.filterId;
                sortDirection = sortField.sortDirection;
            }

            let filterColumns = [];
            let filterValues = [];
            let zipcode = "";

            for (let i = 0; i < searchFields.fields.length; i++)
            {
                let searchField = searchFields.fields[i];
                if (searchField.filterId === "zip" && searchField.selectedValue.length > 0) {
                    zipcode = searchField.selectedValue;
                } else if (searchField.selectedValue.length > 0) {
                    filterColumns.push(searchField.filterId);
                    filterValues.push(encodeURIComponent(searchField.selectedValue));
                } else if (searchField.selectedValues.length > 0) {
                    filterColumns.push(searchField.filterId);
                    filterValues.push(searchField.selectedValues.filter(x=>x.length > 0).map(x=> encodeURIComponent(x)).join(";"));
                }
            }

            let remoteUrl = Helpers.getBaseUrl(inventoryType) + "?pagesize=" + Settings.pageSize + "&currentpage=" + page;
            if (sortColumn > 0)
            {
                remoteUrl += "&sortby=" + sortColumn;
            }

            if (sortDirection === "asc" || sortDirection === "desc")
            {
                remoteUrl += "&sortdirection=" + sortDirection;
            }

            if (zipcode.length > 0)
            {
                remoteUrl += "&zip=" + zipcode + "&milesradius=4000";
            }

            if (filterColumns.length > 0)
            {
                remoteUrl += "&usewildcards=Y&filterid=" + filterColumns.join(",") + "&filter=" + encodeURIComponent(filterValues.join(","));
            }

            let totalResultsPromise = fetch(remoteUrl + "&action=recordcount")
                .then(function(response){return response.text();})
                .then((responseText) => {
                    let parser = new window.DOMParser();
                    let resultsXML = parser.parseFromString(responseText, "text/xml");
                    let totalResults = resultsXML.getElementsByTagName("count")[0].textContent;
                    return totalResults;
                }
            );
            //</editor-fold>

            let searchResultsPromise = null;

            if (inventoryType === Settings.inventoryTypes.TRAILER) {
                searchResultsPromise = fetch(remoteUrl)
                    .then(function (response) {
                        return response.text();
                    })
                    .then((responseText) => {
                        let parser = new window.DOMParser();
                        let resultsXML = parser.parseFromString(responseText, "text/xml");
                        let resultsNodes = resultsXML.getElementsByTagName("trailers");
                        let results = [];
                        for (let i = 0; i < resultsNodes.length; i++) {
                            let trailer = resultsNodes[i];
                            results.push({
                                id: TryRead(trailer, "c_id"),
                                title: TryRead(trailer, "c_year") + " " + TryRead(trailer, "c_manu") + " " + TryRead(trailer, "c_model"),
                                price: parseFloat(TryRead(trailer, "c_price")),
                                salePrice: parseFloat(TryRead(trailer, "c_saleprice")),
                                thumbnail: TryRead(trailer, "t_xpathth1"),
                                caption: TryRead(trailer, "t_com1"),
                                description: TryRead(trailer, "c_description"),
                                dateStarted: moment(TryRead(trailer, "c_startdate")),
                                isReduced: TryRead(trailer, "c_r") === "R",
                                isSold: TryRead(trailer, "c_sold_date").length > 0,
                                distance: parseFloat(TryRead(trailer, "Distance")),
                                extraFields: [{
                                    name: "Size",
                                    value: TryRead(trailer, "c_horses"),
                                    showOnResults: true,
                                }, {
                                    name: "LQ",
                                    value: TryRead(trailer, "c_liv"),
                                    showOnResults: true,
                                }, {
                                    name: "Stock",
                                    value: TryRead(trailer, "c_stock"),
                                    showOnResults: false,
                                },
                                ]
                            });
                        }

                        return results;
                    });
            }

            if (inventoryType === Settings.inventoryTypes.CARGO) {
                searchResultsPromise = fetch(remoteUrl)
                    .then(function (response) {
                        return response.text();
                    })
                    .then((responseText) => {
                        let parser = new window.DOMParser();
                        let resultsXML = parser.parseFromString(responseText, "text/xml");
                        let resultsNodes = resultsXML.getElementsByTagName("cargo");
                        let results = [];
                        for (let i = 0; i < resultsNodes.length; i++) {
                            let trailer = resultsNodes[i];
                            results.push({
                                id: TryRead(trailer, "ct_id"),
                                title: TryRead(trailer, "ct_year") + " " + TryRead(trailer, "ct_manu") + " " + TryRead(trailer, "ct_model"),
                                price: parseFloat(TryRead(trailer, "ct_price")),
                                salePrice: parseFloat(TryRead(trailer, "ct_price")),
                                thumbnail: TryRead(trailer, "IMGTHUMB1"),
                                caption: TryRead(trailer, "COM1"),
                                description: TryRead(trailer, "ct_description"),
                                dateStarted: moment(TryRead(trailer, "ct_startdate")),
                                isReduced: TryRead(trailer, "ct_r") === "R",
                                isSold: TryRead(trailer, "ct_solddate").length > 0,
                                distance: parseFloat(TryRead(trailer, "Distance")),
                                extraFields: [{
                                    name: "Type",
                                    value: TryRead(trailer, "ct_type"),
                                    showOnResults: true,
                                }, {
                                    name: "Pull",
                                    value: TryRead(trailer, "ct_pull"),
                                    showOnResults: true,
                                }, {
                                    name: "Stock",
                                    value: TryRead(trailer, "ct_stock"),
                                    showOnResults: false,
                                },
                                ]
                            });
                        }

                        return results;
                    });
            }

            if (inventoryType === Settings.inventoryTypes.TRUCK) {
                searchResultsPromise = fetch(remoteUrl)
                    .then(function (response) {
                        return response.text();
                    })
                    .then((responseText) => {
                        let parser = new window.DOMParser();
                        let resultsXML = parser.parseFromString(responseText, "text/xml");
                        let resultsNodes = resultsXML.getElementsByTagName("trucks");
                        let results = [];
                        for (let i = 0; i < resultsNodes.length; i++) {
                            let trailer = resultsNodes[i];
                            results.push({
                                id: TryRead(trailer, "t_id"),
                                title: TryRead(trailer, "t_year") + " " + TryRead(trailer, "t_make") + " " + TryRead(trailer, "t_model"),
                                price: parseFloat(TryRead(trailer, "t_price")),
                                salePrice: parseFloat(TryRead(trailer, "t_price")),
                                thumbnail: TryRead(trailer, "t_xpathth1"),
                                caption: TryRead(trailer, "t_com1"),
                                description: TryRead(trailer, "t_description"),
                                dateStarted: moment(TryRead(trailer, "t_startdate")),
                                isReduced: TryRead(trailer, "t_r") === "R",
                                isSold: TryRead(trailer, "t_solddate").length > 0,
                                distance: parseFloat(TryRead(trailer, "Distance")),
                                extraFields: [{
                                    name: "Mileage",
                                    value: TryRead(trailer, "t_mileage"),
                                    showOnResults: true,
                                }, {
                                    name: "Engine",
                                    value: TryRead(trailer, "t_engine"),
                                    showOnResults: true,
                                }, {
                                    name: "Drive",
                                    value: TryRead(trailer, "t_drive"),
                                    showOnResults: true,
                                }, {
                                    name: "Stock",
                                    value: TryRead(trailer, "t_stock"),
                                    showOnResults: false,
                                },
                                ]
                            });
                        }

                        return results;
                    });
            }

            if (inventoryType === Settings.inventoryTypes.PART) {
                searchResultsPromise = fetch(remoteUrl)
                    .then(function (response) {
                        return response.text();
                    })
                    .then((responseText) => {
                        let parser = new window.DOMParser();
                        let resultsXML = parser.parseFromString(responseText, "text/xml");
                        let resultsNodes = resultsXML.getElementsByTagName("trailerparts");
                        let results = [];
                        for (let i = 0; i < resultsNodes.length; i++) {
                            let trailer = resultsNodes[i];
                            results.push({
                                id: TryRead(trailer, "t_id"),
                                title: TryRead(trailer, "t_year") + " " + TryRead(trailer, "t_make") + " " + TryRead(trailer, "t_model"),
                                price: parseFloat(TryRead(trailer, "t_price")),
                                salePrice: parseFloat(TryRead(trailer, "t_price")),
                                thumbnail: TryRead(trailer, "t_xpathth1"),
                                caption: TryRead(trailer, "t_com1"),
                                description: TryRead(trailer, "t_description"),
                                dateStarted: moment(TryRead(trailer, "t_startdate")),
                                isReduced: TryRead(trailer, "t_r") === "R",
                                isSold: TryRead(trailer, "t_solddate").length > 0,
                                distance: parseFloat(TryRead(trailer, "Distance")),
                                extraFields: [{
                                    name: "",
                                    value: TryRead(trailer, "CategoryName"),
                                    showOnResults: true,
                                }, {
                                    name: "Year",
                                    value: TryRead(trailer, "t_year"),
                                    showOnResults: true,
                                }, {
                                    name: "Stock",
                                    value: TryRead(trailer, "t_stock"),
                                    showOnResults: false,
                                },
                                ]
                            });
                        }

                        return results;
                    });
            }

            let searchPagedResultsPromise = Promise.all([searchResultsPromise, totalResultsPromise])
                .then(values => {
                    return ({
                            results: values[0],
                            currentPage: page,
                            totalPages: Math.ceil(values[1]/Settings.pageSize),
                            totalRecords: values[1]
                        });
                });

            return searchPagedResultsPromise;
        }

        if (inventoryType === Settings.inventoryTypes.INVENTORY) {

            let searchObj = {
                inventoryQueryGroups: []
            };


            for (let i = 0; i < searchFields.fields.length; i++)
            {
                let searchField = searchFields.fields[i];

                if (searchField.selectedValue && searchField.selectedValue.length > 0) {
                    searchObj.inventoryQueryGroups.push(
                        {
                            inventoryQueries : [
                                {
                                    queryType: searchField.inventoryQueryType,
                                    question: parseInt(searchField.filterId) || 0,
                                    term: searchField.selectedValue
                                }
                            ]
                        }
                    );
                }
                else if (searchField.selectedValues && searchField.selectedValues.length > 0)
                {
                    searchObj.inventoryQueryGroups.push(
                        {
                            inventoryQueries: searchField.selectedValues.map(
                                (val) =>
                                {
                                    let obj ={
                                        queryType: searchField.inventoryQueryType,
                                        question: parseInt(searchField.filterId) || 0,
                                        term: val
                                    };
                                    return obj;
                                }
                            )
                        }
                    );
                }
            }

            let postDataObject = {
                ListingCategoryId : inventoryCategoryId,
                Page: page,
                MemberId: Settings.memberId,
                QueryList: JSON.stringify(searchObj)
            };

            let postDataArray = [];
            for (let property in postDataObject) {
                let encodedKey = encodeURIComponent(property);
                let encodedValue = encodeURIComponent(postDataObject[property]);
                postDataArray.push(encodedKey + "=" + encodedValue);
            }

            let postDataString = postDataArray.join("&");

            let inventoryPromise1 = fetch(Settings.baseApi + "Listings/Search/",
                {
                    method: 'POST',
                    withCredentials: true,
                    credentials: 'omit',
                    headers: {
                        Authorization: Settings.authHeader,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                    },
                    body: postDataString
                })
                .then(result => { return result.json()})
                .then(result => {

                    let results = [];
                    for (let itemIndex = 0; itemIndex < result.results.items.length; itemIndex++) {
                        let record = result.results.items[itemIndex];
                        results.push({
                            id: record.listingId,
                            title: record.title,
                            price: record.price,
                            salePrice: record.price,
                            thumbnail: record.thumbnail,
                            caption: record.title,
                            description: record.description,
                            dateStarted: moment(record.startDate),
                            isReduced: record.reduced,
                            isSold: record.isSold,
                            distance: record.proxDistance,
                            extraFields: [
                                {
                                    name: "City",
                                    value: record.contactCity,
                                    showOnResults: true,
                                },
                                {
                                    name: "State",
                                    value: record.contactState,
                                    showOnResults: true,
                                },
                            ]
                        });
                    }
                    return ({
                        results: results,
                        currentPage: page,
                        totalPages: result.results.totalPages,
                        totalRecords: result.results.totalItems
                    });
                });

            return inventoryPromise1;
        }
        return [];
    }

    GetDetails(inventoryType, listingId) {
        debugger;
        if (inventoryType === Settings.inventoryTypes.TRAILER ||
            inventoryType === Settings.inventoryTypes.CARGO ||
            inventoryType === Settings.inventoryTypes.TRUCK ||
            inventoryType === Settings.inventoryTypes.PART) {

            let remoteUrl = Helpers.getBaseUrl(inventoryType) + "?id=" + listingId;
            let detailsPromise = fetch(remoteUrl)
                .then(function(response){return response.text();})
                .then((result) =>
                {
                    let detailsResult = null;
                    // IgnoreAttrs = true , otherwise elements with attributes get returned as complex objects instead of scalar values
                    parseXml(result, { ignoreAttrs: true},  function (err, result) {
                        if (inventoryType === Settings.inventoryTypes.TRAILER && result.NewDataSet.trailers && result.NewDataSet.trailers.length > 0) {
                            detailsResult = result.NewDataSet.trailers[0];
                        }
                        if (inventoryType === Settings.inventoryTypes.CARGO && result.NewDataSet.cargo && result.NewDataSet.cargo.length > 0) {
                            detailsResult = result.NewDataSet.cargo[0];
                        }
                        if (inventoryType === Settings.inventoryTypes.TRUCK && result.NewDataSet.trucks && result.NewDataSet.trucks.length > 0) {
                            detailsResult = result.NewDataSet.trucks[0];
                        }
                        if (inventoryType === Settings.inventoryTypes.PART && result.NewDataSet.trailerparts && result.NewDataSet.trailerparts.length > 0) {
                            detailsResult = result.NewDataSet.trailerparts[0];
                        }
                        return null;
                    });
                    return detailsResult;
                })

            return detailsPromise;
        }

        if (inventoryType === Settings.inventoryTypes.INVENTORY) {
            let inventoryPromise1 = fetch(Settings.baseApi + "Listing/" + listingId,
                {
                    method: 'GET',
                    withCredentials: true,
                    credentials: 'omit',
                    headers: {
                        Authorization: Settings.authHeader
                    },
                })
                .then(result => { return result.json()})
                .then(result => {
                    return result.results;
                });
            return inventoryPromise1;
        }
    }

    GetInventoryCategories() {

        if (typeof this.cache["categories"] !== "undefined")
        {
            return Promise.resolve(this.cache["categories"]);
        }

        let me = this;

        let categoriesPromise = fetch(Settings.baseApi + "Listings/Categories/?IncludeHidden=false&MemberId=" + Settings.memberId,
            {
                method: 'GET',
                withCredentials: true,
                credentials: 'omit',
                headers: {
                    Authorization: Settings.authHeader
                }
            })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                me.cache["categories"] = response.results;
                return response.results;
            });

        return categoriesPromise;
    }
}

let DefaultSearchHandler = new SearchHandler();
export { DefaultSearchHandler }